import { useState } from 'react';
import { DropDownMenu } from 'uikit/dropDownMenu/dropDownMenu.component';
import { DropDownMenuOption } from 'uikit/dropDownMenu/dropDownMenu';

export type SettingsMenuProps = {
  menuItems: DropDownMenuOption[];
  defaultItem?: DropDownMenuOption;
  onSelect?: (item: DropDownMenuOption) => void;
  customComponent?: JSX.Element;
  className?: string;
};

export const SettingsMenu = ({ menuItems, defaultItem, onSelect, customComponent, className }: SettingsMenuProps) => {
  const [selectedItem, setSelectedItem] = useState<DropDownMenuOption | undefined>(defaultItem);
  // @ts-ignore
  const appMenuItems: DropDownMenuOption[] = menuItems.map((item) => {
    return {
      ...item,
      action: () => {
        setSelectedItem(item);
        onSelect?.(item);
        item.action?.();
      },
    };
  });

  return (
    // @ts-ignore
    <DropDownMenu
      closeCalloutByClick
      hasChevron
      options={appMenuItems}
      colorSchema={'black'}
      text={selectedItem?.text}
      customComponent={customComponent}
      className={className}
    />
  );
};
